import { useState, useEffect, useContext } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { fetchUserData } from "../components/auth";
import { UserDataContext } from "./UserDataContext";
import LogoutIcon from "@mui/icons-material/Logout";
import DateComponent from "./DateComponent";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import GroupsIcon from "@mui/icons-material/Groups";
import SecurityIcon from "@mui/icons-material/Security";
import EngineeringIcon from "@mui/icons-material/Engineering";
import "./Menu.css";
import { NavLink } from "react-router-dom";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { apiRequest } from "../components/Config";

function VN() {
  const navigate = useNavigate();
  const { userData, setUserData } = useContext(UserDataContext);
  const [expire, setExpire] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [menuItems, setMenuItems] = useState([]);
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) setIsOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (userData && (userData.permId === "1" || userData.permId === "3")) {
      setMenuItems([
        {
          id: 1,
          name: "DOKUMENTY",
          path: "/files",
          icon: <FolderCopyIcon />,
        },
        {
          id: 2,
          name: "KONTRAHENCI",
          path: "/performers",
          icon: <GroupsIcon />,
        },
        {
          id: 3,
          name: "ADMIN",
          path: "/internalUsers",
          icon: <SecurityIcon />,
        },
        {
          id: 4,
          name: "wyloguj",
          path: "/login",
          action: logout,
          icon: <LogoutIcon onClick={logout} />,
        },
      ]);
    }
    if (userData && userData.permId === "2") {
      setMenuItems([
        {
          id: 1,
          name: "MOJE DOKUMENTY",
          path: "/files",
          icon: <FormatListNumberedIcon />,
        },

        {
          id: 4,
          name: "",
          path: "/login",
          icon: <LogoutIcon onClick={logout} />,
        },
      ]);
    }
    if (userData && userData.permId === "0") {
      setMenuItems([{ id: 1, name: "", path: "/login" }]);
    }
  }, [userData, setMenuItems]);

  const logout = async () => {
    console.log("tu jestem1");
    try {
      await apiRequest("logout", "POST");
      setUserData({
        userId: 0,
        user: "",
        permId: "0",
        fullName: "",
        grpName: "",
        description: "",
        is_active: "0",
        phone: "",
        idGrp: "0",
      });
      console.log("tu jestem2");
      //navigate("/login");
    } catch (error) {
      console.error("Błąd podczas wylogowywania:", error);
    }
  };

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const userDataAnswer = await fetchUserData();
        if (userDataAnswer && userDataAnswer.userId) {
          setUserData(userDataAnswer);
          setExpire(userDataAnswer.expire);
        } else {
          navigate("/login");
        }
      } catch (error) {
        console.error("Error during user verification:", error);

        navigate("/login");
      } finally {
        setLoading(false);
      }
    };
    verifyUser();
  }, [navigate, setUserData]);

  useEffect(() => {
    if (expire) {
      const compareDateWithToday = (inputDate) => {
        const today = new Date();
        const input = new Date(inputDate);
        today.setHours(0, 0, 0, 0);
        input.setHours(0, 0, 0, 0);
        if (input < today) {
          navigate("/expired");
        }
      };
      compareDateWithToday(expire);
    }
  }, [expire, navigate]);

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      <header className="menu-container">
        {/* LOGO */}
        <p className="p8">{!loading && userData ? userData.fullName : ""}</p>

        {/* HAMBURGER - tylko na mobile */}
        {isMobile && (
          <button className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? "✖" : "☰"}
          </button>
        )}

        {/* MENU */}
        {!loading && userData && (
          <nav
            className={`menu ${
              isMobile ? (isOpen ? "open" : "closed") : "desktop"
            }`}
          >
            <ul>
              {menuItems.map((item) => (
                <li key={item.id}>
                  <NavLink
                    to={item.path}
                    className={({ isActive }) => (isActive ? "active" : "")}
                    onClick={(e) => {
                      if (item.action) {
                        e.preventDefault();
                        item.action();
                        navigate(item.path);
                      }
                      if (isMobile) setIsOpen(false);
                    }}
                  >
                    <p className="p4">
                      {item.icon} {item.name}
                    </p>
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        )}
        {!loading && userData && userData.permId === "1" && (
          <Tooltip title="Ustawienia">
            <SettingsOutlinedIcon
              onClick={handleOpenUserMenu}
              style={{
                color: "#000000",
                display: "block",
                paddingBottom: "0px",
                marginRight: "120px",
              }}
            />
          </Tooltip>
        )}

        {!loading && userData && (
          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            <MenuItem key="passchange" onClick={() => navigate("/passchange")}>
              <Typography sx={{ textAlign: "center" }}>Zmiana hasła</Typography>
            </MenuItem>

            {userData.permId === "1" && (
              <>
                <MenuItem
                  key="categories"
                  onClick={() => navigate("/categories")}
                >
                  <Typography sx={{ textAlign: "center" }}>
                    Kategorie
                  </Typography>
                </MenuItem>
                <MenuItem key="projects" onClick={() => navigate("/projects")}>
                  <Typography sx={{ textAlign: "center" }}>Projekty</Typography>
                </MenuItem>
                <MenuItem key="types" onClick={() => navigate("/doctypes")}>
                  <Typography sx={{ textAlign: "center" }}>
                    Typy dokumentów
                  </Typography>
                </MenuItem>
              </>
            )}
          </Menu>
        )}
      </header>
    </>
  );
}

export default VN;
